import React, { useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Intent, Alert } from '@blueprintjs/core';

import { validateResetToken, resetPassword } from '../../../api/authApi';

import logoBackground from './css/img/Atual Clube - Marca_Laranja 1.svg'
import logo from './css/img/logo.svg';

import './css/changePassword.css';
import { lerTokenDoCookie } from '../../../shared/cookie-da-sessao';

const ChangePasswordPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [tokenValid, setTokenValid] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAlertOpen, setIsAlertOpen] = useState<boolean>(false);

  const params = new URLSearchParams(location.search);
  const token = params.get('token');  

  useEffect(() => {
    const checkLoggedIn = () => {
      const tokenCookie = lerTokenDoCookie();

      if (tokenCookie) {
        navigate('/home');
      }
    };

    checkLoggedIn();
  }, [navigate]);

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setError('Token de redefinição de senha não encontrado.');
        return;
      }
    
      try {
        await validateResetToken(token);
        setTokenValid(true);
      } catch (err) {
        setError('Token inválido ou expirado.');
        setTokenValid(false);
      }
    };

    validateToken();
  }, [token]);

  const handleChangePassword = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!token) {
      setError('Token de redefinição de senha não encontrado.');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('As novas senhas não coincidem.');
      return;
    }

    if (!tokenValid) {
      setError('Token inválido ou expirado.');
      return;
    }

    setIsLoading(true);

    try {
      setError(null);
      // A rota pública valida o token de reset no backend e o invalida após o uso.
      const response = await resetPassword(token, newPassword, confirmPassword);
      setMessage(response.message);
      setIsAlertOpen(true);

      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError('Erro ao trocar a senha: ' + (error instanceof Error ? error.message : 'Erro desconhecido'));
      setMessage(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAlertConfirm = () => {
    setIsAlertOpen(false);
    navigate('/login');
  };

  return (
    <div className='main-containt'>
      <img className='logo-background' src={logoBackground} alt="Logo de fundo" />
      <div className="form-container-change">
      <img src={logo} alt="logo atual" />
        <form className="form-change" onSubmit={handleChangePassword}>
          <div className="change-div">
            <div className='div-title-error'>
            <h1 className="h1-auth">Alterar Senha</h1>

            {message && <span className="success-message">{message}</span>}
            {error && <span className="error-message">{error}</span>}
            {isLoading && <span className="loading-message">Carregando...</span>}
            
            </div>
            <div className="change-fields">
              <p>Informe sua nova senha:</p>
              <div className="nice-form-group change">
                <input 
                  id="newPassword" 
                  name="newPassword" 
                  className="nice-input" 
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Nova Senha"
                  required 
                  disabled={isLoading}
                />
              </div>

              <div className="nice-form-group change">
                <input 
                  id="confirmPassword" 
                  name="confirmPassword" 
                  className="nice-input" 
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirme a Nova Senha"
                  required 
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="button-div change">
              <Button 
                type="submit" 
                intent={Intent.PRIMARY} 
                disabled={!tokenValid || isLoading}
                className={!tokenValid || isLoading ? 'disabled-button' : 'enabled-button'}
              >
                {isLoading ? 'Alterando...' : 'Alterar Senha'}
              </Button>
            </div>
          </div>
        </form>
      </div>

      <Alert
        isOpen={isAlertOpen}
        confirmButtonText="OK"
        onClose={handleAlertConfirm}
        intent={Intent.SUCCESS}
      >
        <p>Senha alterada com sucesso!</p>
      </Alert>
    </div>
  );
};

export default ChangePasswordPage;
